export default __webpack_public_path__ + "static/media/smartphone.da3fd621.svg";